var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPayIn40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20632)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5294 12.2676C17.5294 9.08388 14.9485 6.50293 11.7647 6.50293C8.58095 6.50293 6 9.08388 6 12.2676C6 15.4514 8.58095 18.0323 11.7647 18.0323C14.9485 18.0323 17.5294 15.4514 17.5294 12.2676Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5294 28.7383C17.5294 25.5546 14.9485 22.9736 11.7647 22.9736C8.58095 22.9736 6 25.5546 6 28.7383C6 31.9221 8.58095 34.503 11.7647 34.503C14.9485 34.503 17.5294 31.9221 17.5294 28.7383Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 12.2676C34.0001 9.08388 31.4192 6.50293 28.2354 6.50293C25.0517 6.50293 22.4707 9.08388 22.4707 12.2676C22.4707 15.4514 25.0517 18.0323 28.2354 18.0323C31.4192 18.0323 34.0001 15.4514 34.0001 12.2676Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 28.7383C34.0001 25.5546 31.4192 22.9736 28.2354 22.9736C25.0517 22.9736 22.4707 25.5546 22.4707 28.7383C22.4707 31.9221 25.0517 34.503 28.2354 34.503C31.4192 34.503 34.0001 31.9221 34.0001 28.7383Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPayIn40);
export default __webpack_public_path__ + "static/media/pictogramBeaconPayIn40.2c35004c3284ea85121399dfaba040ba.svg";
export { ForwardRef as ReactComponent };